<template>
    <div>
        <div class="vertical-flow">
            <div class="listing-header">
                <div class="title-breadcrumb"></div>
                <div class="header-buttons">
                    <button
                        v-if="!cantEdit"
                        class="save-btn"
                        type="button"
                        @click="save"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
            <div class="page-container sem-margem-bottom mt-4 mb-4">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-6">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(5)"
                                        ref="prazoPagtoSelect"
                                        :options="prazoPagtoSelect"
                                        v-model="prazoPagtoSelected"
                                        title="prazo-pgto-padrao"
                                        tooltipLabel="msg-tooltip-financeiro-prazo-pgto"
                                        tooltipSize="is-small"
                                        :required="true"
                                        :invalid="isNull(prazoPagtoSelected)"
                                        @input="sendIsChanged"
                                        :disabled="cantEdit"
                                    />
                                </div>
                                <div
                                    v-if="!prazoPagtoIntegracao"
                                    class="control padding-label padding-label-custom"
                                >
                                    <b-button
                                        @click="showModalCadastroPrazoPagto = true"
                                        icon-right="plus"
                                        :disabled="isLoading"
                                        v-tippy 
                                        :title="$t('ven-cliente-geral-ppgto')"
                                    />
                                </div>
                            </div>
                            <b-modal :active.sync="showModalCadastroPrazoPagto">
                                <div>
                                    <PrazoPagamentoCadastroModal
                                        v-if="showModalCadastroPrazoPagto"
                                        :permissaoVincular="permissao.update"
                                        :idCliente="$route.params.id"
                                        @fecharModal="fecharModalPrazoPagtoWithValue($event)"
                                    />
                                </div>
                            </b-modal>
                        </div>
                        <div class="column is-6">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(10)"
                                        ref="formaPagtoSelect"
                                        :options="formaPagtoSelect"
                                        v-model="formaPagtoSelected"
                                        title="forma-pgto-padrao"
                                        tooltipLabel="msg-tooltip-financeiro-forma-pgto"
                                        tooltipSize="is-small"
                                        :required="true"
                                        :invalid="isNull(formaPagtoSelected)"
                                        @input="sendIsChanged"
                                        :disabled="cantEdit"
                                    />
                                </div>
                                <div
                                    v-if="!formaPagtoIntegracao"
                                    class="control padding-label padding-label-custom"
                                >
                                    <b-button
                                        @click="showModalCadastroFormaPagto = true"
                                        icon-right="plus"
                                        :disabled="isLoading"
                                        v-tippy 
                                        :title="$t('adicionar-forma-pagamento')"
                                    />
                                </div>
                            </div>
                            <b-modal :active.sync="showModalCadastroFormaPagto">
                                <div>
                                    <FormaPagamentoCadastroModal
                                        v-if="showModalCadastroFormaPagto"
                                        :permissaoVincular="permissao.update"
                                        :idCliente="$route.params.id"
                                        @fecharModal="fecharModalFormaPagtoWithValue($event)"
                                    />
                                </div>
                            </b-modal>
                        </div>
                        <div class="column is-6">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(15)"
                                        ref="tabPrecoVendaSelect"
                                        :options="tabelasPrecoSelect"
                                        v-model="tabelaPrecoVendaSelected"
                                        title="tabela-preco-venda-padrao"
                                        tooltipLabel="msg-tooltip-financeiro-tab-preco"
                                        tooltipSize="is-small"
                                        :required="true"
                                        :invalid="isNull(tabelaPrecoVendaSelected)"
                                        @input="sendIsChanged"
                                        :disabled="cantEdit"
                                    />
                                </div>
                                <div
                                    v-if="!tabelaPrecoIntegracao"
                                    class="control padding-label padding-label-custom"
                                >
                                    <b-button
                                        @click="
                                            $router.push({
                                                name: `${abrev}-tabelapreco-new`,
                                                query: {
                                                    tela: `${abrev}-cliente-financeiro`,
                                                    id: $route.params.id,
                                                    dadoscadastrais: $route.query
                                                        .dadoscadastrais
                                                        ? $route.query.dadoscadastrais
                                                        : null,
                                                    politicacomercial: 8,
                                                    analisecomercial: $route.query
                                                        .analisecomercial
                                                        ? $route.query.analisecomercial
                                                        : null,
                                                },
                                            })
                                        "
                                        icon-right="plus"
                                        :disabled="isLoading"
                                        v-tippy 
                                        :title="$t('adicionar-tabela-preco')"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(20)"
                                        ref="tabPrecoTrocaSelect"
                                        :options="tabelasPrecoSelect"
                                        v-model="tabelaPrecoTrocaSelected"
                                        title="tabela-preco-troca-padrao"
                                        tooltipLabel="msg-tooltip-financeiro-tab-preco-troca"
                                        tooltipSize="is-small"
                                        :required="true"
                                        :invalid="isNull(tabelaPrecoTrocaSelected)"
                                        @input="sendIsChanged"
                                        :disabled="cantEdit"
                                    />
                                </div>
                                <div
                                    v-if="!tabelaPrecoIntegracao"
                                    class="control padding-label padding-label-custom"
                                >
                                    <b-button
                                        :disabled="isLoading"
                                        @click="
                                            $router.push({
                                                name: `${abrev}tabelapreco-new`,
                                                query: {
                                                    tela: `${abrev}-cliente-financeiro`,
                                                    id: $route.params.id,
                                                    dadoscadastrais: $route.query
                                                        .dadoscadastrais
                                                        ? $route.query.dadoscadastrais
                                                        : null,
                                                    politicacomercial: 8,
                                                    analisecomercial: $route.query
                                                        .analisecomercial
                                                        ? $route.query.analisecomercial
                                                        : null,
                                                },
                                            })
                                        "
                                        icon-right="plus"
                                        v-tippy 
                                        :title="$t('adicionar-tabela-preco')"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <vss-select
                                        :id="generateId(25)"
                                        ref="tabPrecoBonificacaoSelect"
                                        :options="tabelasPrecoSelect"
                                        v-model="tabelaPrecoBonificacaoSelected"
                                        title="tabela-preco-bonificacao-padrao"
                                        tooltipLabel="msg-tooltip-financeiro-tab-preco-bonificacao"
                                        tooltipSize="is-small"
                                        :required="true"
                                        :invalid="isNull(tabelaPrecoBonificacaoSelected)"
                                        @input="sendIsChanged"
                                        :disabled="cantEdit"
                                    />
                                </div>
                                <div
                                    v-if="!tabelaPrecoIntegracao"
                                    class="control padding-label padding-label-custom"
                                >
                                    <b-button
                                        @click="
                                            $router.push({
                                                name: `${abrev}-tabelapreco-new`,
                                                query: {
                                                    tela: `${abrev}-cliente-financeiro`,
                                                    id: $route.params.id,
                                                    dadoscadastrais: $route.query
                                                        .dadoscadastrais
                                                        ? $route.query.dadoscadastrais
                                                        : null,
                                                    politicacomercial: 8,
                                                    analisecomercial: $route.query
                                                        .analisecomercial
                                                        ? $route.query.analisecomercial
                                                        : null,
                                                },
                                            })
                                        "
                                        icon-right="plus"
                                        v-tippy 
                                        :title="$t('adicionar-tabela-preco')"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- @84474 - Inseridos campos de tipo pedido e recebimento parcial -->
                        <div class="column is-6">
                            <div class="control is-expanded">
                                <vss-select
                                    :id="generateId(27)"
                                    ref="tipoPedidoSelect"
                                    :options="tipoPedidoSelect"
                                    v-model="tipoPedidoSelected"
                                    title="vincular-tipo-pedido"
                                    tooltipLabel="msg-tooltip-financeiro-tipo-pedido"
                                    tooltipSize="is-small"
                                    @input="sendIsChanged"
                                    :disabled="cantEdit"
                                />
                            </div>
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(26)"
                                ref="recebimentoparcial"
                                title="recebimento-parcial"
                                :searchable="false"
                                :options="selecaoSimNao"
                                v-model="recebimentoParcialSelected"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                tooltipLabel="msg-tooltip-financeiro-recebimento-parcial"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div class="column is-12">
                            <hr />
                            <small class="mt-4 mb-4">
                                <b>{{ $t('financeiro-aviso-vinculo-parte-um') }}</b>
                                {{ $t('financeiro-aviso-vinculo-parte-dois') }}
                                <i class="fas fa-exclamation icon is-small"></i>
                                {{ $t('financeiro-aviso-vinculo-parte-tres') }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-container sem-margem-bottom mt-4 mb-4">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-money
                                :id="generateId(30)"
                                ref="coeficientePreco"
                                v-model="financeiro.coeftabpreco"
                                title="coeficiente-preco"
                                :required="true"
                                tooltipLabel="msg-tooltip-financeiro-coef-tab-preco"
                                tooltipSize="is-small"
                                :msg="
                                    financeiro.coeftabpreco > 99999999.99
                                        ? 'msg-qtd-acima'
                                        : 'msg-qtd-zero-invalid'
                                "
                                :invalid="
                                    financeiro.coeftabpreco < 0 ||
                                    financeiro.coeftabpreco > 99999999.99
                                "
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(35)"
                                ref="flex"
                                class="no-clear"
                                title="ignora-regra-flex"
                                tooltipLabel="msg-tooltip-financeiro-flex"
                                tooltipSize="is-small"
                                v-model="ignoraRegraFlexSelected"
                                :required="true"
                                :invalid="isNull(ignoraRegraFlexSelected)"
                                :searchable="false"
                                :options="selecaoSimNao"
                                :mlLabels="true"
                                @input="sendIsChanged"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(40)"
                                ref="icms"
                                class="no-clear"
                                v-model="contribuinteICMSSelected"
                                title="contribuinte-icms"
                                :required="true"
                                :invalid="isNull(contribuinteICMSSelected)"
                                :searchable="false"
                                :options="selecaoSimNao"
                                :mlLabels="true"
                                @input="sendIsChanged"
                                :disabled="cantEdit"
                                tooltipLabel="msg-tooltip-financeiro-contribuinte-icms"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(45)"
                                ref="farmacia"
                                class="no-clear"
                                v-model="farmaciaPopularSelected"
                                title="farmacia-popular"
                                tooltipLabel="msg-tooltip-financeiro-farmacia-popular"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :required="true"
                                :invalid="isNull(farmaciaPopularSelected)"
                                :searchable="false"
                                :options="selecaoSimNao"
                                :mlLabels="true"
                                @input="sendIsChanged"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(50)"
                                class="height-36"
                                ref="prazo"
                                title="prazo-entrega"
                                v-model="financeiro.prazoentrega"
                                :useMask="true"
                                :vMask="['########']"
                                :msg="
                                    financeiro.prazoentrega > 99999999
                                        ? 'msg-qtd-acima'
                                        : 'msg-qtd-zero-invalid'
                                "
                                :invalid="
                                    financeiro.prazoentrega < 0 ||
                                    financeiro.prazoentrega > 99999999
                                "
                                :disabled="cantEdit"
                                tooltipLabel="msg-tooltip-financeiro-prazoentrega"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(55)"
                                ref="frequencia"
                                class="height-36"
                                title="frequencia-compra"
                                tooltipLabel="msg-tooltip-financeiro-frequencia-entrega"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :useMask="true"
                                :vMask="['########']"
                                v-model="financeiro.frequenciacompra"
                                :msg="
                                    financeiro.frequenciacompra > 99999999
                                        ? 'msg-qtd-acima'
                                        : 'msg-qtd-zero-invalid'
                                "
                                :invalid="
                                    financeiro.frequenciacompra < 0 ||
                                    financeiro.frequenciacompra > 99999999
                                "
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(60)"
                                class="height-36"
                                ref="estoqueSeguranca"
                                title="estoque-seguranca"
                                tooltipLabel="msg-tooltip-financeiro-estoque-seguranca"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :useMask="true"
                                :vMask="['###']"
                                v-model="financeiro.estoqueseguranca"
                                :msg="
                                    financeiro.estoqueseguranca > 100.0
                                        ? 'msg-porcentagem-invalida'
                                        : 'msg-porcentagem-invalida'
                                "
                                :invalid="
                                    financeiro.estoqueseguranca < 0 ||
                                    financeiro.estoqueseguranca > 100.0
                                "
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <v-money
                                :id="generateId(65)"
                                class="height-36"
                                ref="cif"
                                title="valor-minimo-cif"
                                v-model.number="financeiro.valorminimocif"
                                :msg="
                                    financeiro.valorminimocif > 99999999.99
                                        ? 'msg-qtd-acima'
                                        : 'msg-qtd-zero-invalid'
                                "
                                :invalid="
                                    financeiro.valorminimocif < 0 ||
                                    financeiro.valorminimocif > 99999999.99
                                "
                                :disabled="cantEdit"
                                tooltipLabel="msg-tooltip-financeiro-valorminimocif"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                            />
                        </div>
                        <div class="column is-4">
                            <v-money
                                :id="generateId(70)"
                                ref="fob"
                                class="height-36"
                                title="valor-minimo-fob"
                                v-model="financeiro.valorminimofob"
                                :msg="
                                    financeiro.valorminimofob > 99999999.99
                                        ? 'msg-qtd-acima'
                                        : 'msg-qtd-zero-invalid'
                                "
                                :invalid="
                                    financeiro.valorminimofob < 0 ||
                                    financeiro.valorminimofob > 99999999.99
                                "
                                :disabled="cantEdit"
                                tooltipLabel="msg-tooltip-financeiro-valorminimofob"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                            />
                        </div>
                        <!-- @84474 - Adicionado campo de desconto maximo e codoperacaocom -->
                        <div class="column is-4">
                            <v-input
                                :id="generateId(61)"
                                class="height-36"
                                ref="descontoMaximo"
                                title="desconto-maximo"
                                tooltipLabel="msg-tooltip-financeiro-desconto-maximo"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :useMask="true"
                                :vMask="['###']"
                                v-model="financeiro.descontomaximo"
                                :msg="
                                    financeiro.descontomaximo > 100.0
                                        ? 'msg-porcentagem-invalida'
                                        : 'msg-porcentagem-invalida'
                                "
                                :invalid="
                                    financeiro.descontomaximo < 0 ||
                                    financeiro.descontomaximo > 100.0
                                "
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(51)"
                                ref="codoperacaocom"
                                v-model="financeiro.codoperacaocom"
                                placeholder="placeholder-preencha"
                                title="cod-operacao-comercial"
                                msg="cod-operacao-comercial"
                                tooltipLabel="msg-tooltip-financeiro-cod-operacao-comercial"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :disabled="cantEdit"
                                :maxlength="50"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import FinanceiroService from '@/services/vendas/cliente/abas/FinanceiroService';
import AssTipoPedidoClienteService from '@/services/vendas/cliente/abas/AssTipoPedidoClienteService';
import FinanceiroValidation from '@/services/validations/vendas/FinanceiroValidation';
import PrazoPagamentoCadastroModal from '@/components/vendas/cliente/modal/PrazoPagamentoCadastroModal';
import FormaPagamentoCadastroModal from '@/components/vendas/cliente//modal/FormaPagamentoCadastroModal';
import { TheMask } from 'vue-the-mask';
import { mapState } from 'vuex';

export default {
    components: {
        TheMask,
        HideInfo,
        PrazoPagamentoCadastroModal,
        FormaPagamentoCadastroModal,
    },
    props: {
        idCliente: 0,
    },
    data() {
        return {
            validation: new FinanceiroValidation(this.$root.msgs),
            service: new FinanceiroService(this.$http, this.$router),
            tipoPedidoService: new AssTipoPedidoClienteService(this.$http, this.$router),
            msgs: [],

            //possíveis estados da tela
            isLoading: false,
            isSaving: false,
            isLoadingEdit: false,
            carregouPrazosPagto: false,
            carregouFormasPagto: false,
            carregouTabelasPreco: false,
            carregouTiposPedido: false,
            carregouDadosTela: false,

            //objeto para comunicação com o service e o backend
            financeiro: {
                idformapagto: null,
                idprazopagto: null,
                coeftabpreco: 0,
                idtabpreco: null,
                idtabprecotroca: null,
                idtabprecobonificacao: null,
                ignoraregraflex: null,
                valorminimofob: 0,
                valorminimocif: 0,
                prazoentrega: null,
                frequenciacompra: null,
                estoqueseguranca: null,
                contribuinteicms: null,
                farmpopular: null,
                recebimentoparcial: 'N',
                idtipopedido: null,
                codoperacaocom: null,
                descontomaximo: 0,
            },
            recebimentoParcialSelected: { label: 'nao', id: 0 },

            //listas para receber valores das combobox
            prazoPagtoSelect: [],
            formaPagtoSelect: [],
            tabelasPrecoSelect: [],
            tipoPedidoSelect: [],

            //variáveis para armazenar os valores selecionados nas combobox
            prazoPagtoSelected: null,
            formaPagtoSelected: null,
            tabelaPrecoVendaSelected: null,
            tabelaPrecoTrocaSelected: null,
            tabelaPrecoBonificacaoSelected: null,
            ignoraRegraFlexSelected: null,
            contribuinteICMSSelected: null,
            farmaciaPopularSelected: null,
            tipoPedidoSelected: null,

            //variáveis para determinar se os modais são ou não exibidos
            showModalCadastroFormaPagto: false,
            showModalCadastroPrazoPagto: false,

            //lista para combobox booleanas
            selecaoSimNao: [
                { label: 'nao', id: 0 },
                { label: 'sim', id: 1 },
            ],

            //permissões de acesso aos modais de cadastro
            prazoPagtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRAZOPAGTO'),
            formaPagtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('FORMAPAGTO'),
            tabelaPrecoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('TABPRECO'),
            clienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes('CLIENTE'),

            cantEdit: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-financeiro'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-financeiro'
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.cantEdit = this.clienteIntegracao || !this.permissao.update;

            this.isLoading = true;
            this.isLoadingEdit = true;

            this.carregarDados();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        financeiro: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-financeiro-' + numberId;
        },
        sendIsChanged() {
            if (!this.isLoadingEdit) this.$emit('isChanged', true);
        },
        carregarDados() {
            this.service
                .loadFinanceiro(this.$route.params.id)
                .then((r) => {
                    if (r.status == 200) {
                        r.content.map((m) => {
                            this.financeiro.idformapagto = m.idformapagto;
                            this.financeiro.idprazopagto = m.idprazopagto;
                            this.financeiro.coeftabpreco = m.coeftabpreco;
                            this.financeiro.idtabpreco = m.idtabpreco;
                            this.financeiro.idtabprecotroca = m.idtabprecotroca;
                            this.financeiro.idtabprecobonificacao = m.idtabprecobonificacao;
                            this.financeiro.ignoraregraflex = m.ignoraregraflex;
                            this.financeiro.valorminimofob = m.valorminimofob;
                            this.financeiro.valorminimocif = m.valorminimocif;
                            this.financeiro.prazoentrega = m.prazoentrega;
                            this.financeiro.frequenciacompra = m.frequenciacompra;
                            this.financeiro.estoqueseguranca = m.estoqueseguranca;
                            this.financeiro.contribuinteicms = m.contribuinteicms;
                            this.financeiro.farmpopular = m.farmpopular;
                            this.financeiro.recebimentoparcial = m.recebimentoparcial;
                            this.financeiro.idtipopedido = m.idtipopedido;
                            this.financeiro.codoperacaocom = m.codoperacaocom;
                            this.financeiro.descontomaximo = m.descontomaximo;
                            this.setAllFromID();
                        });
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao carregar dados financeiros.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar dados financeiros.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.carregouDadosTela = true;
                    this.carregarPrazosPagto();
                    this.carregarFormasPagto();
                    this.carregarTiposPedido();
                    this.carregarListaTabelasPreco();
                    this.isLoadingEdit = false;
                });
        },

        //FUNÇÃO PARA DEFINIR NAS COMBOBOX OS ITENS SELECIONADOS A PARTIR DE SEUS IDS
        setAllFromID() {
            let recebimentoparcial = 0;
            if (this.financeiro.recebimentoparcial === 'S') {
                recebimentoparcial = 1;
            }
            this.ignoraRegraFlexSelected = this.selecaoSimNao[this.financeiro.ignoraregraflex];
            this.contribuinteICMSSelected = this.selecaoSimNao[this.financeiro.contribuinteicms];
            this.farmaciaPopularSelected = this.selecaoSimNao[this.financeiro.farmpopular];
            this.recebimentoParcialSelected = this.selecaoSimNao[recebimentoparcial];
        },

        //FUNÇÕES PARA CARREGAR DADOS DAS COMBOBOX
        // @84474 - Carregamento dos tipos de pedido que estão vinculados ao usuário
        carregarTiposPedido() {
            this.findAll('tipo-pedido', 'asc', 0, 999, 3, this.$route.params.id, '')
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idtipopedido,
                            label: m.tipopedido.descricao,
                            replicapda: m.replicapda,
                        };
                    });
                })
                .then((r) => {
                    this.tipoPedidoSelect = r;
                    if (this.financeiro.idtipopedido != null) {
                        this.tipoPedidoSelected = this.tipoPedidoSelect.find(
                            (e) => e.id == this.financeiro.idtipopedido
                        );
                        if (!this.tipoPedidoSelected) {
                            this.tipoPedidoSelected = null;
                        }
                    }
                })
                .finally((_) => {
                    this.carregouTiposPedido = true;
                    this.carregouTudo();
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.tipoPedidoService.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.tipoPedidoService.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        carregarPrazosPagto() {
            this.service
                .loadPrazosPgto(this.$route.params.id)
                .then((body) => {
                    return body.content.map((r) => {
                        return {
                            id: r.idprazopagto,
                            label: r.descricao,
                            cor: '#999999',
                            icone: r.acessoATabelaAssociativa == 0 ? 'fas fa-exclamation' : null, //adiciona ícone para indicar os prazos de pagamento sem vínculo ao cliente
                        };
                    });
                })
                .then((r) => {
                    this.prazoPagtoSelect = r;
                    //Caso dado da combobox venha do banco, já seleciona o valor recebido na combobox
                    if (this.financeiro.idprazopagto != null) {
                        this.prazoPagtoSelected = this.prazoPagtoSelect.find(
                            (e) => e.id == this.financeiro.idprazopagto
                        );
                    }
                })
                .finally((_) => {
                    this.carregouPrazosPagto = true;
                    this.carregouTudo();
                });
        },
        carregarFormasPagto() {
            this.service
                .loadFormasPgto(this.$route.params.id)
                .then((body) => {
                    return body.content.map((r) => {
                        return {
                            id: r.idformapagto,
                            label: r.descricao,
                            cor: '#999999',
                            icone: r.acessoATabelaAssociativa == 0 ? 'fas fa-exclamation' : null, //adiciona ícone para indicar os prazos de pagamento sem vínculo ao cliente
                        };
                    });
                })
                .then((r) => {
                    this.formaPagtoSelect = r;
                    //Caso dado da combobox venha do banco, já seleciona o valor recebido na combobox
                    if (this.financeiro.idformapagto != null) {
                        this.formaPagtoSelected = this.formaPagtoSelect.find(
                            (e) => e.id == this.financeiro.idformapagto
                        );
                    }
                })
                .finally((_) => {
                    this.carregouFormasPagto = true;
                    this.carregouTudo();
                });
        },
        carregarListaTabelasPreco() {
            this.service
                .loadTabPreco(this.$route.params.id)
                .then((body) => {
                    return body.content.map((r) => {
                        return {
                            id: r.idtabpreco,
                            label: r.descricao,
                            cor: '#999999',
                            icone: r.acessoATabelaAssociativa == 0 ? 'fas fa-exclamation' : null, //adiciona * para indicar os prazos de pagamento sem vínculo ao cliente
                        };
                    });
                })
                .then((r) => {
                    this.tabelasPrecoSelect = r;

                    //Caso dado de uma das combobox venha do banco, já seleciona o valor recebido na combobox
                    if (this.financeiro.idtabpreco != null) {
                        this.tabelaPrecoVendaSelected = this.tabelasPrecoSelect.find(
                            (e) => e.id == this.financeiro.idtabpreco
                        );
                    }
                    if (this.financeiro.idtabprecotroca != null) {
                        this.tabelaPrecoTrocaSelected = this.tabelasPrecoSelect.find(
                            (e) => e.id == this.financeiro.idtabprecotroca
                        );
                    }
                    if (this.financeiro.idtabprecobonificacao != null) {
                        this.tabelaPrecoBonificacaoSelected = this.tabelasPrecoSelect.find(
                            (e) => e.id == this.financeiro.idtabprecobonificacao
                        );
                    }
                })
                .finally((_) => {
                    this.carregouTabelasPreco = true;
                    this.carregouTudo();
                });
        },
        carregouTudo() {
            //Pára carregamento (loading) apenas após todos os dados terem sido recebidos do back
            if (
                this.carregouTabelasPreco &&
                this.carregouPrazosPagto &&
                this.carregouFormasPagto &&
                this.carregouTiposPedido &&
                this.carregouDadosTela
            ) {
                this.isLoading = false;
                this.isLoadingEdit = false;
            }
        },
        mapObjectsToIDs() {
            // @84474 - Definição do objeto que será passado ao backend
            this.financeiro.contribuinteicms =
                this.contribuinteICMSSelected.id != null ? this.contribuinteICMSSelected.id : 0;
            this.financeiro.ignoraregraflex =
                this.ignoraRegraFlexSelected.id != null ? this.ignoraRegraFlexSelected.id : 0;
            this.financeiro.farmpopular =
                this.farmaciaPopularSelected.id != null ? this.farmaciaPopularSelected.id : 0;
            this.financeiro.idprazopagto =
                this.prazoPagtoSelected != null ? this.prazoPagtoSelected.id : 0;
            this.financeiro.idformapagto =
                this.formaPagtoSelected != null ? this.formaPagtoSelected.id : 0;
            this.financeiro.idtabpreco =
                this.tabelaPrecoVendaSelected != null ? this.tabelaPrecoVendaSelected.id : 0;
            this.financeiro.idtabprecotroca =
                this.tabelaPrecoTrocaSelected != null ? this.tabelaPrecoTrocaSelected.id : 0;
            this.financeiro.idtabprecobonificacao =
                this.tabelaPrecoBonificacaoSelected != null
                    ? this.tabelaPrecoBonificacaoSelected.id
                    : 0;
            this.financeiro.recebimentoparcial =
                this.recebimentoParcialSelected != null
                    ? this.recebimentoParcialSelected.id == 1
                        ? 'S'
                        : 'N'
                    : 'N';
            this.financeiro.idtipopedido =
                this.tipoPedidoSelected != null ? this.tipoPedidoSelected.id : 0;
        },
        save() {
            this.isLoading = true;
            this.mapObjectsToIDs();

            if (this.validation.validate(this.financeiro, this.$refs)) {
                let financeiroTemp = Object.assign({}, this.financeiro);
                financeiroTemp = this.mapTosave(financeiroTemp);
                financeiroTemp.idcliente = this.$route.params.id;
                this.isSaving = true;
                this.saveFinanceiro(financeiroTemp)
                    .then((value) => {
                        if (value.message == null) {
                            this.$root.showMessage('success', 'msg-save-financeiro');
                        } else {
                            if (this.$t(value.message)) {
                                this.$root.showMessage('alert', value.message);
                            } else {
                                this.$root.showMessage('error', 'msg-problema-realizar-acao');
                            }
                        }
                    })
                    .catch((e) => {
                        console.error('Erro', e);
                        this.$root.showMessage('error', 'msg-erro-load');
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.$root.showMessage('error', 'msg-preencher-campos-obrigatorios-corretamente');
                this.isLoading = false;
            }
        },
        saveFinanceiro(financeiro) {
            if (this.isVenda) return this.service.saveVendas(financeiro);
            else return this.service.saveAgro(financeiro);
        },
        //FUNÇÕES PARA FECHAMENTO DO MODAL, SELECIONAM O VALOR ADICIONADO NO BANCO PELO MODAL
        fecharModalPrazoPagtoWithValue(data) {
            if (data != null) {
                let tempPrazoPagto = {
                    id: data.idprazopagto,
                    label: data.descricao,
                    cor: '#999999',
                    icone: 'fas fa-exclamation',
                };
                this.prazoPagtoSelect.push(tempPrazoPagto);
                this.prazoPagtoSelected = tempPrazoPagto;
                this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-prazo-pgto');
            }
            this.showModalCadastroPrazoPagto = false;
        },
        fecharModalFormaPagtoWithValue(data) {
            if (data != null) {
                let tempFormaPagto = {
                    id: data.idprazopagto,
                    label: data.descricao,
                    cor: '#999999',
                    icone: 'fas fa-exclamation',
                };
                this.formaPagtoSelect.push(tempFormaPagto);
                this.formaPagtoSelected = tempFormaPagto;
                this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-forma-pgto');
            }
            this.showModalCadastroFormaPagto = false;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}

.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
    .sem-margem-bottom {
        .columns:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
